import './MobileNavbar.scss';

import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { DefaultAvatar } from 'atoms/default-avatar';
import Icon from 'atoms/icon';

import { MobileNavbarItem } from './MobileNavbarItem';

export function MobileNavbar() {
  const location = useLocation();
  const { locations } = useSelector((state) => state.provider);
  const avatar = locations?.[0]?.links?.image?.mobile?.small;

  const isInPage = (pathname) => location.pathname.includes(pathname);

  return (
    <div className="mobile-navbar">
      <MobileNavbarItem
        path="/today"
        isActive={isInPage('/today')}
        icon={<Icon name="calendarNumber" />}
        text="Today"
      />
      <MobileNavbarItem
        path="/appointments"
        isActive={isInPage('/appointments')}
        icon={<Icon name="list" />}
        text="Appointments"
      />
      <MobileNavbarItem
        path="/clients/1"
        isActive={isInPage('/clients')}
        icon={<Icon name="pawStraight" />}
        text="Clients"
      />
      <MobileNavbarItem
        path="/payment-history/1"
        isActive={isInPage('/payment-history')}
        icon={<Icon name="wallet" />}
        text="Payments"
      />
      <MobileNavbarItem
        path="/services"
        isActive={isInPage('/services') || isInPage('/team')}
        icon={<DefaultAvatar avatar={avatar} size="extra-small" />}
        text="Profile"
      />
    </div>
  );
}
